<div class="card-header bg-white border-0 d-flex align-items-center justify-content-between pb-0">
    <h4 class="m-0">{{ 'hub.console.organizations.connected-to-the-magaya-network' | translate }}</h4>
    <img alt="{{ 'hub.console.organizations.magaya-logo' | translate }}" src="https://cdn.qwyk.io/portals/assets/providers/catapult-qms.png" width="130">
</div>

<div class="card-body">
    <div class="row border-bottom pb-5">
        <div class="col-12 col-lg-4">
            <p class="lead">{{ 'hub.common.basic-information' | translate }}</p>
        </div>
        <div class="col">
            <div class="p-fluid mb-3">
                <label for="network_id">{{ 'hub.console.organizations.network-id' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.network_id" disabled id="network_id" pInputText
                       type="text">
            </div>
            <div class="p-fluid mb-3">
                <label for="company_name">{{ 'portal.settings.profile.company-name' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.company_name" disabled id="company_name" pInputText
                       type="text">
            </div>
            <div class="p-fluid mb-3">
                <label for="superuser_username">{{ 'hub.console.organizations.superuser-username' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.superuser_username" disabled id="superuser_username"
                       pInputText type="text">
            </div>
            <div class="p-fluid mb-3">
                <label for="connection_uri">{{ 'hub.console.organizations.connection' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.connection_uri" disabled id="connection_uri" pInputText
                       type="text">
            </div>
            <div class="p-fluid text-right mb-3">
                <button (click)="edit.emit()" class="btn btn-primary">{{ 'common.edit' | translate }}</button>
            </div>
        </div>
    </div>

    <div class="row pt-5 pb-2">
        <div class="col-12 col-lg-4">
            <p class="lead">{{ 'common.status' | translate }}</p>
        </div>
        <div class="col">
            <div class="p-fluid mb-3">
                <label for="connection_status">{{ 'hub.console.organizations.connection' | translate }}</label>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon border-right-0 pr-0" style="background-color: #f8f9fa;">
                        <fa-icon
                            class="font-weight-bold"
                            [icon]="['fas', connectionStatusIcon]"
                            [ngClass]="connectionStatusStyle"
                            [animation]="$any(iconAnimation)"
                        ></fa-icon>
                    </span>
                    <input [ngModel]="connectionStatusText" disabled id="connection_status"
                           class="border-right-0 border-left-0" pInputText
                           type="text" [ngClass]="connectionStatusStyle">
                    <button
                        (click)="onTestConnection()"
                        class="border-1 border-left-0 px-2 p-input-text text-primary" pButton
                        [disabled]="loading"
                        pTooltip="{{ 'hub.console.organizations.test-connection-tooltip' | translate }}">
                        <fa-icon [icon]="['far', 'sync' ]" [animation]="$any(iconAnimation)" class="mr-2"></fa-icon>
                        {{ 'hub.console.organizations.test' | translate }}
                    </button>
                </div>
            </div>

            <div *ngIf="magayaNetworkConfiguration.last_connection_at" class="p-fluid mb-3">
                <label for="last_connection_at">{{ 'hub.home.last-checked' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.last_connection_at | amTimeAgo" disabled
                       id="last_connection_at" pInputText
                       type="text">
            </div>

            <div *ngIf="magayaNetworkConfiguration.last_connection_error_message" class="p-fluid mb-3">
                <label for="last_connection_error_message">{{ 'portal.conversations.message' | translate }}</label>
                <textarea [ngModel]="magayaNetworkConfiguration.last_connection_error_message" disabled
                          id="last_connection_error_message" pInputTextarea
                          rows="3"></textarea>
            </div>

            <div class="p-fluid mb-3">
                <label for="current_ltm_version">{{ 'hub.console.organizations.ext-ltm-version' | translate }}</label>
                <input [ngModel]="magayaNetworkConfiguration.current_ltm_version" disabled id="current_ltm_version"
                       pInputText type="text">
            </div>

            <div class="p-fluid mb-3">
                <label for="recommended_ltm_version">{{ 'hub.console.organizations.required-version' | translate }}</label>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon pr-0" style="background-color: #f8f9fa">
                        <fa-icon
                            class="font-weight-bold"
                            [icon]="['fas', magayaNetworkConfiguration.satisfies_required_version ? 'check-circle' : 'exclamation-triangle']"
                            [ngClass]=" magayaNetworkConfiguration.satisfies_required_version ? 'text-success' : 'text-danger'"
                        ></fa-icon>
                    </span>
                    <input [ngModel]="magayaNetworkConfiguration.required_ltm_version" disabled
                           id="required_ltm_version" pInputText
                           class="border-left-0"
                           [ngClass]=" magayaNetworkConfiguration.satisfies_required_version ? 'text-success' : 'text-danger'"
                           type="text">
                </div>
            </div>

            <div class="p-fluid mb-3">
                <label for="recommended_ltm_version">{{ 'hub.console.organizations.recommended-version' | translate }}</label>
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon pr-0" style="background-color: #f8f9fa">
                        <fa-icon
                            class="font-weight-bold"
                            [icon]="['fas', magayaNetworkConfiguration.satisfies_recommended_version ? 'check-circle' : 'exclamation-triangle']"
                            [ngClass]=" magayaNetworkConfiguration.satisfies_recommended_version ? 'text-success' : 'text-warning'"
                        ></fa-icon>
                    </span>
                    <input [ngModel]="magayaNetworkConfiguration.recommended_ltm_version" disabled id="recommended_ltm_version" pInputText
                           class="border-left-0"
                           type="text" [ngClass]=" magayaNetworkConfiguration.satisfies_recommended_version ? 'text-success' : 'text-warning'">
                </div>
            </div>
        </div>
    </div>
</div>
